export enum BalanceTransactionStatusEnum {
  PROVISIONED = "PROVISIONED",
  AVAILABLE = "AVAILABLE",
  PRE_AVAILABLE = "PRE_AVAILABLE",
  DEBITED = "DEBITED"
}

export const BalanceTypeLabel = new Map<BalanceTransactionStatusEnum, string>([
  [BalanceTransactionStatusEnum.PROVISIONED, "Provisionado"],
  [BalanceTransactionStatusEnum.AVAILABLE, "Disponível"],
  [BalanceTransactionStatusEnum.PRE_AVAILABLE, "Pré Disponível"],
  [BalanceTransactionStatusEnum.DEBITED, "Utilizado"],
]);



// WEBPACK FOOTER //
// ./src/services/Enum/BalanceTransactionStatusEnum.ts